
import React, { useEffect, useState } from 'react';

// MUI Components
import { makeStyles } from '@mui/styles';  // Still use @mui/styles for makeStyles
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ListIcon from '@mui/icons-material/List';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import BackupIcon from '@mui/icons-material/Backup';

// Custom Components and Utilities
import { bindActionCreators } from 'redux';
import * as Actions from "../actions";
import * as Position_Actions from "../position-section/position_actions";
import { connect } from 'react-redux';
import { GPAP_Button, GPAP_Button_Light } from "../../../../../../../../../../gpap-lib/components/Button_Collection";
import GPAP_Tooltip from "../../../../../../../../../../gpap-lib/components/GPAP_Tooltip";
import MappedText from '../../../../../../../../../study-page/create-study/analysis-page/components/clinical-info/mapText';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

function parseFile(file, fileType){


    const bedlines = file;
    let ranges = [];
    let read_error = undefined;


    bedlines.forEach(function(row){
        let values = row.split("\t");
        let chr = values[0];
        let startpos = parseInt(values[1]);
        let endpos = values[2] !== undefined ? parseInt(values[2]) : startpos;

        //If chr columns starts with 'chr'

        if (chr.startsWith("chr")){
            chr = chr.split("chr")[1];
        }
        //Sex chromosomes handling
        switch (chr) {
            case 'X':
                chr = 24;
                break;
            case 'Y':
                chr = 25;
                break;
            case 'MT':
                chr = 23;
                break;
            case "M":
                chr = 23
        }

        //Push all rows except for headers (can start with # of just text)
        if (parseInt(chr)){

            chr = chr.toString().replace(/ /g, '');
            let start_pos = startpos.toString().replace(/ /g, '');
            let end_pos =   endpos.toString().replace(/ /g, '');

            //If it is comma separated,space separated or does not have 3 columns
            if ((chr.indexOf(',') !== -1) || (start_pos.indexOf(',') !== -1) || (end_pos.indexOf(',') !== -1) || (chr.indexOf(' ') !== -1) || (start_pos.indexOf(' ') !== -1) || (end_pos.indexOf(' ') !== -1) || isNaN(chr) || isNaN(start_pos) || isNaN(end_pos) ) {

                read_error = (fileType === "BED")
                    ? "Wrong bed file format (it must be tab-delimited). Please see here: https://genome.ucsc.edu/FAQ/FAQformat.html#format1"
                    : "Wrong variant file format (it must be tab-delimited)"
            }

            ranges.push('{"chrom"' + ":" + chr + ',"pos"' + ":" + start_pos + ',"end_pos"' + ":" + end_pos + "}");

        }


    });





    return {"ranges": ranges, error: read_error}
}


function UploadFile(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    let {fileType, position_actions, position_uploads} = props;

    // variant_ranges
    // bed_ranges

    const [list, setList] = useState([]);

    // Global "Reset all filters" clears Redux ranges; keep local upload UI in sync.
    useEffect(() => {
        const count = fileType === "BED"
            ? (position_uploads?.bed_ranges?.length ?? 0)
            : (position_uploads?.coordinate_ranges?.length ?? 0);
        if (count === 0 && list.length > 0) {
            setList([]);
        }
    }, [fileType, position_uploads, list.length]);


    const readFile = (file) => {

        let obj = parseFile(file, fileType);
        if(obj.error === undefined){
            setList(obj.ranges);
            if(fileType === "BED"){

                position_actions.add_bed_ranges(obj.ranges)
            }
            else{
                position_actions.add_coordinate_ranges(obj.ranges)
            }
        }
        else{
            alert("Error");
        }

    };





    const handleFile = (input) => {

        const reader = new FileReader();
        reader.onload = function(){
            // Normalize CRLF / LF / old Mac CR so each physical line becomes one array entry.
            // split('\r\n') alone misses Unix LF-only files and treats the whole file as one line.
            const normalized = reader.result.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            const file = normalized.split('\n').filter((line) => line.trim().length > 0);

            readFile(file)



        };
        reader.readAsText(input.target.files[0]);

    };

    const clear = () => {

        setList([]);
        props.position_actions.reset_ranges(fileType)

    };


    let buttonText, tooltipTitle;
    if (fileType === "BED") {
        buttonText = t("Upload BED File");
        tooltipTitle = `${t("Tab delimited file e.g:")}\n1 13868 14652\n3 39100 41808`;
    } else {
        buttonText = t("Upload coordinate File");
        tooltipTitle = `${t("Tab delimited file e.g:")}\n#chr Position\n8 14652`;
    }

    return (
        <Box p={0}>
            {/*{(fileType === "BED")
                ? <Typography variant={"subtitle1"}>Upload BED File</Typography>
                : <Typography variant={"subtitle1"}>Upload Coordinate File</Typography>
            }*/}
            {(list.length === 0)
                ? <div className={classes.root}>
                    <input
                        accept="text/*"
                        className={classes.input}
                        id="contained-button-file"
                        multiple
                        type="file"
                        onChange={handleFile}
                    />
                    <label htmlFor="contained-button-file" style={{width: "100%"}}>
                        <GPAP_Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{tooltipTitle}</div>}>
                        <GPAP_Button variant="contained" component="span" size = {"small"} startIcon={<BackupIcon/>}>
                            {buttonText}
                        </GPAP_Button>
                        </GPAP_Tooltip>
                    </label>
                </div>
                : <Typography variant={"subtitle1"}> <DoneIcon color={"primary"}/> Uploaded {list.length} range from {fileType} File <IconButton onClick={clear}><ClearIcon/></IconButton></Typography>
            }
        </Box>
    );
}


function mapStateToProps (state) {
    if(state.authorization!==undefined) {
        return {
            token: state.authorization.token,
            position_uploads: state.position_uploads
        };

    }
    else{
        return {token: "", position_uploads: { bed_ranges: [], coordinate_ranges: [] }}
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
    position_actions: bindActionCreators(Position_Actions, dispatch)
});


export default connect(mapStateToProps,mapDispatchToProps)(UploadFile);